import _ from 'lodash';
import { createSelector } from 'reselect';
import { getValidEncodes } from '../utils/platforms';

export const selectVCardContentState = state => _.get(state, 'Vcard.content');
export const selectVCardContentSerieState = state =>
  _.get(state, 'Vcard.serie');
export const selectVCardPBIState = state => _.get(state, 'Vcard.PBI');
export const selectVCardBookmarksSeriesState = state =>
  _.get(state, 'Vcard.bookmarks.menuSeries');
export const selectVCardBookmarksInfoSectionState = state =>
  _.get(state, 'Vcard.bookmarks.infoSection');
export const selectVcardRecommendations = state =>
  _.get(state, 'Vcard.recommendations');
export const selectVcardFavorite = state => _.get(state, 'Vcard.favorite');

export const isContentSerie = group =>
  Boolean(_.get(group, 'common.extendedcommon.media.serie'));

export const selectIsContentLoading = createSelector(
  [selectVCardContentState],
  state => state.isLoading,
);
export const selectVCardContent = createSelector(
  [selectVCardContentState],
  state => {
    const isSerie = isContentSerie(state.group);
    const title = isSerie
      ? _.get(state, 'group.common.extendedcommon.media.serie.title', '')
      : _.get(state, 'group.common.title', '');

    const types = _.get(
      state,
      'group.common.extendedcommon.format.types',
      '',
    ).split(',');
    const isLive = _.get(state, 'group.common.extendedcommon.media.islive', '');

    const episodeTitle = _.get(state, 'group.common.title', '');
    const duration = _.get(state, 'group.common.duration', '');
    const ranking = _.get(state, 'group.common.ranking', {});
    const genres = _.get(state, 'group.common.extendedcommon.genres.genre', []);
    const groupId = _.get(state, 'group.common.id', null);
    const titleUri = _.get(state, 'group.common.title_uri', '');
    const imageStill = _.get(state, 'group.common.image_still');
    const imageBaseHorizontal = _.get(state, 'group.common.image_base_horizontal');
    const episode = _.get(
      state,
      'group.common.extendedcommon.media.episode',
      {},
    );
    const originalTitle = isSerie
      ? _.get(state, 'group.common.extendedcommon.media.serie.title', '')
      : _.get(state, 'group.common.extendedcommon.media.originaltitle', '');

    const publishDate = _.get(
      state,
      'group.common.extendedcommon.media.publishyear',
      '',
    );
    const rate = _.get(state, 'group.common.extendedcommon.media.rating', {});
    const descriptionExtended = _.get(
      state,
      'group.common.extendedcommon.media.description_extended',
      '',
    );
    const shortDescription = state?.group?.common?.description;
    const largeDescription = state?.group?.common?.large_description;
    const smallImage = _.get(state, 'group.common.image_base_vertical', null);
    const largeImage = _.get(state, 'group.common.image_base_horizontal', null);
    const languages = _.get(
      state,
      'group.common.extendedcommon.media.language.options.option',
      [],
    );
    const hasPreview =
      _.get(state, 'group.common.extendedcommon.media.haspreview', 'false') ===
      'true';

    const proveedorCode = _.get(
      state,
      'group.common.extendedcommon.media.proveedor.codigo',
      '',
    );

    const info = {
      title,
      group_id: groupId,
      titleUri,
      hasPreview,
      episodeTitle,
      episode,
      originalTitle,
      descriptionExtended,
      shortDescription,
      largeDescription,
      ranking,
      rate,
      duration,
      publishDate,
      isSerie,
      isLive,
      genres,
      smallImage,
      largeImage,
      languages,
      proveedorCode,
      types,
      imageStill,
      imageBaseHorizontal
    };
    return info;
  },
);

export const selectTalentContent = createSelector(
  [selectVCardContentState],
  state => {
    const extend = _.get(state, 'group.common.extendedcommon.roles.role', []);
    const external = _.get(state, 'group.external.gracenote.cast', []);
    const extendRoles = extend.map(role => {
      const rawTalents = role.talents.talent || role.talents;
      const talents = rawTalents.map(t => ({
        ...t,
        first_name: t.first_name || t.name,
        last_name: t.last_name || t.surname,
      }));
      const eRole = {
        ...role,
        role_name: role.role_name || role.name,
        talents,
      };
      return eRole;
    });

    return {
      default: extendRoles.map(r => ({ ...r, provider: 2 })),
      gracenote:
        external.length > 0
          ? external.map(r => ({ ...r, provider: 3 }))
          : extendRoles.map(r => ({ ...r, provider: 2 })),
      node: external.length > 0 ? 'gracenote' : 'default',
    };
  },
);

export const selectEncode = language => state => {
  const validEncodes = getValidEncodes();
  const languages = _.get(
    state,
    'Vcard.content.group.common.extendedcommon.media.language.options.option',
    [],
  );
  if (languages.length === 0) return {};

  if (!language) {
    const defaultLanguage = languages[0];
    const encode = validEncodes.filter(value =>
      defaultLanguage.encodes.includes(value),
    );
    return encode[0] || null;
  }
  return {};
};

export const selectPBIBanner = createSelector(
  [selectVCardPBIState],
  PBIState => _.get(PBIState, 'infoPBI.bannerpromo', ''),
);

export const getConfigdata = state => _.get(state, 'config');

export const getTranslateState = state => _.get(state, 'translations');

export const getConfigFacebook = ({ country, url }) =>
  createSelector(
    getConfigdata,
    getTranslateState,
    (configData, translate) => ({
      btnLabelShare: _.get(translate, 'stb_btn_share'),
      btnFacebookShare: {
        appID: _.get(configData, 'facebook_app_id'),
        urlToShare: `https://www.clarovideo.com${url}?sharemeta=true`,
        locale: country === 'brasil' ? 'pt_BR' : 'es_ES',
      },
    }),
  );
